import {View} from '@fantasmagames/slot/src/common/view/View';
import {HTMLCreationUtils} from '@fantasmagames/core/src/html/HTMLCreationUtils';

export class OrientationView extends View {
	public static readonly ORIENTATION_CHANGED_TO_PORTRAIT: string = 'OrientationView::ORIENTATION_CHANGED_TO_PORTRAIT';
	public static readonly ORIENTATION_CHANGED_TO_LANDSCAPE: string = 'OrientationView::ORIENTATION_CHANGED_TO_LANDSCAPE';

	protected _background: HTMLElement;
	protected _image: HTMLImageElement;

	protected _debugText: PIXI.Text;
	protected _debugText2: PIXI.Text;
	protected _debugText3: PIXI.Text;

	/*	protected _fullscreenTouchImage: HTMLImageElement;
		protected _fullscreenTouchBackground: HTMLElement;
		protected _fullscreenTouchTween: Tween;*/

	public init(): void {
		super.init();

		// (window as any).debugText1 = this.addDebugText('Debug1');
		// (window as any).debugText2 = this.addDebugText('Debug2', 250);
		// (window as any).debugText3 = this.addDebugText('Debug3', 350);

		if (this.device.isMobile) {
			this.setupGraphicElements();
		}
	}

	private addDebugText(text: string, y: number = 150, x: number = this.resolutionManager.halfResolution.width / 2): PIXI.Text {
		const debugText = new PIXI.Text(text, this.textStyles.freeRoundsCaptionStyle);
		debugText.position.x = x;
		debugText.position.y = y;
		this.container.addChild(debugText);

		return debugText;
	}

	public onPortrait(): void {
		super.onPortrait();
		setTimeout(() => {
			this.toggleNotification(true);
		}, 0);
		this.emit(OrientationView.ORIENTATION_CHANGED_TO_PORTRAIT);
	}

	public onLandscape(): void {
		super.onLandscape();
		setTimeout(() => {
			this.toggleNotification(false);
		}, 0);

		this.emit(OrientationView.ORIENTATION_CHANGED_TO_LANDSCAPE);
	}

	public onFullscreenEntered(): void {
		super.onFullscreenEntered();
		/*
				if (!this.device.isIframe && this.device.android) {
					this.hideFullscreenTouchOverlay();
				}*/
	}

	public onFullscreenExited(): void {
		super.onFullscreenExited();

		/*		if (!this.device.isIframe && this.device.android) {
					this.showFullscreenTouchOverlay();
				}*/
	}

	/*	protected startFullscreenTouchIconAnimation(): void {
			this.stopFullscreenTouchIconAnimation();

			const tweenObj = {y: 1};

			this._fullscreenTouchTween = new Tween(tweenObj)
				.to({y: [0.7, 1]}, 1500)
				.easing(Easing.Back.InOut)
				.onUpdate(() => {
					this._fullscreenTouchImage.style.transform = `translateX(-50%) translateY(-50%) scale(${tweenObj.y})`;
					this._fullscreenTouchImage.style.top = `${40 + (tweenObj.y - 0.7) * 10}%`;
				})
				.onComplete(() => {
					this.startFullscreenTouchIconAnimation();
				})
				.repeat(3)
				.start();

			this.updateManager.add(this._fullscreenTouchTween);
		}

		protected stopFullscreenTouchIconAnimation(): void {
			if (this._fullscreenTouchTween && this._fullscreenTouchTween.isPlaying) {
				this._fullscreenTouchTween.stop();
				this._fullscreenTouchImage.style.transform = `translateX(-50%) translateY(-50%) scale(1)`;
			}
		}

		protected showFullscreenTouchOverlay(): void {
			this._fullscreenTouchImage.style.display = 'block';
			this._fullscreenTouchBackground.style.display = 'block';
			this.startFullscreenTouchIconAnimation();
		}

		protected hideFullscreenTouchOverlay(): void {
			this._fullscreenTouchImage.style.display = 'none';
			this._fullscreenTouchBackground.style.display = 'none';
			this.stopFullscreenTouchIconAnimation();
		}

		protected isFullscreenOverlayVisible(): boolean {
			return this._fullscreenTouchImage.style.display === 'block' ? true : false;
		}*/

	protected setupGraphicElements(): void {
		// if (!this._background) {
		this._background = HTMLCreationUtils.createBackground('tiltNotificationBackground');
		this._image = HTMLCreationUtils.createOverlayImage('TILT_ICON.png', this._background, this.resources);
		this._background.style.display = 'none';
		this._image.style.display = 'none';
		/*
				this._fullscreenTouchBackground = HTMLCreationUtils.createBackground('fullscreenNotificationBackground', 'rgba(0,0,0,0.5)');
				this._fullscreenTouchImage = HTMLCreationUtils.createOverlayImage(
					'TOUCH_ICON.png',
					this._fullscreenTouchBackground,
					this.resources,
				);


				this._fullscreenTouchBackground.style.display = 'none';
				this._fullscreenTouchImage.style.display = 'none';

				if (!this.device.android) {
					this.hideFullscreenTouchOverlay();
				}*/
	}

	private isFullscreen(): boolean {
		return !!document[this.device.fullscreenElement];
	}

	protected toggleNotification(isPortrait: boolean): void {
		if (isPortrait) {
			this._image.style.display = 'none';
			this._background.style.display = 'none';

			/*	if (!this.device.isIframe && this.device.android && !this.isFullscreen()) {
					this.showFullscreenTouchOverlay();
				}*/

			this.parent.visible = true;
		} else {
			/*	if (!this.device.isIframe && this.device.android && this.isFullscreenOverlayVisible()) {
					this.hideFullscreenTouchOverlay();
				}*/

			this._image.style.display = 'block';
			this._background.style.display = 'block';

			this.parent.visible = false;
		}
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/orientation/OrientationView.ts